import React from "react";
import styled from "styled-components";
import { WorksBox } from "../";
import { Main } from "../../styles/";

const StyledWorks = styled(Main)`
  display: flex;
  justify-content: center;
  padding-top: 1rem;
`;

export const Works = () => {
  return (
    <StyledWorks>
      <WorksBox />
    </StyledWorks>
  );
};
